/**************************************************
 * Nombre:       Contactos_Portada
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import '@splidejs/react-splide/css';
import fondo from '../../../Recursos/fondos.png'
import {NEGRITA} from "../../../Constantes";
import {theme} from "../../../Tema";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";


const Contactos_Portada = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                mt: -12,
                backgroundImage: `url(${fondo})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
            }}
        >


            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid
                    container
                    justifyContent={'center'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 11}}
                >


                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 6}}
                        sx={{
                            background: '#ffffff50',
                            backdropFilter: 'blur(5px)',
                            color: "#fff",
                            borderBottom: 6,
                            borderColor: theme.palette.info.main,
                            py: 6,
                            px: 6,
                            mt: 24,
                            mb: 14
                        }}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                            <Typography sx={{fontFamily: NEGRITA, fontSize: sCell ? 40 : 62, fontWeight: 600,
                                color: '#fff'}}>
                                Contactos
                            </Typography>
                        </Grid>


                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                            <Typography sx={{fontSize: sCell ? 20 : 24, fontWeight: 600, textAlign: 'center',
                                color: '#fff'}}>
                                Estamos listos para resolver tus dudas e impulsar tu futuro profesional
                            </Typography>
                        </Grid>

                    </Grid>


                </Grid>

            </Grid>


        </Grid>
    )

}
export default Contactos_Portada

